import { graphql } from "../gql";

const getActiveFixturesNflQuery = graphql(`
  query GetActiveFixturesNfl {
    getNflSchedule {
      broadcastInfo {
        network
      }
      id
      numberFireId
      scheduledTime
      clock
      quarter
      status
      headToHeadSlug
      homeTeam {
        code
        logo
        name
        primaryColor
        slug
        sportsbookLink
        stats {
          points
        }
        record {
          wins
          losses
          ties
        }
        winProbability
      }
      awayTeam {
        code
        logo
        name
        primaryColor
        slug
        sportsbookLink
        stats {
          points
        }
        record {
          wins
          losses
          ties
        }
        winProbability
      }
      odds {
        home {
          moneyLine {
            odd
            url
          }
          spread {
            odd
            url
            value
          }
          total {
            odd
            url
            value
          }
        }
        away {
          moneyLine {
            odd
            url
          }
          spread {
            odd
            url
            value
          }
          total {
            odd
            url
            value
          }
        }
      }
    }
  }
`);

export default getActiveFixturesNflQuery;
